type Props = {
  kicker: string;
  title: string;
  desc?: string;
  tone?: "default" | "light";
};

export default function SectionHeading({ kicker, title, desc, tone = "default" }: Props) {
  const isLight = tone === "light";
  return (
    <div className="mb-5 md:mb-7">
      <p
        className={`mb-2 inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide ${
          isLight ? "text-accent-300" : "text-primary-600"
        }`}
      >
        <span className={`h-px w-6 ${isLight ? "bg-accent-300" : "bg-primary-400"}`}></span>
        {kicker}
      </p>
      <h2
        className={`font-heading text-2xl font-extrabold tracking-tight md:text-3xl ${
          isLight ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-2 max-w-2xl text-sm leading-relaxed ${isLight ? "text-background-200" : "text-foreground-500"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}